var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 266.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#143964;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.5,6a6.42,6.42,0,0,1,4.6,1.9l51,51a6.6,6.6,0,0,1,1.9,4.6V254.2a6.49,6.49,0,0,1-6.5,6.5H12.5A6.49,6.49,0,0,1,6,254.2V12.5A6.49,6.49,0,0,1,12.5,6h124m0-6H12.5A12.5,12.5,0,0,0,0,12.5V254.2a12.5,12.5,0,0,0,12.5,12.5h175A12.5,12.5,0,0,0,200,254.2V63.5a12.49,12.49,0,0,0-3.6-8.8l-51-51A12.57,12.57,0,0,0,136.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.31,70.2H152.54A19.57,19.57,0,0,1,133,50.6V3.6A3.5,3.5,0,0,1,136.49.1h0A3.5,3.5,0,0,1,140,3.6v47a12.58,12.58,0,0,0,12.56,12.6h43.77a3.5,3.5,0,0,1,3.49,3.5h0A3.5,3.5,0,0,1,196.31,70.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.09,114.71c-15.11,0-24.74,6.37-32.31,17.67a3.38,3.38,0,0,0,.79,4.56l9.52,7.22a3.4,3.4,0,0,0,4.72-.61c4.93-6.25,8.33-9.87,15.85-9.87,5.66,0,12.67,3.65,12.67,9.14,0,4.16-3.43,6.29-9,9.43-6.53,3.65-15.16,8.2-15.16,19.59v2.83a3.4,3.4,0,0,0,3.4,3.39h15.39a3.4,3.4,0,0,0,3.4-3.39v-2.09c0-7.89,23.06-8.22,23.06-29.58C133.4,126.92,116.72,114.71,101.09,114.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.24,183.49A12.76,12.76,0,1,0,112,196.24,12.76,12.76,0,0,0,99.24,183.49Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileEmpty);
export default __webpack_public_path__ + "static/media/FileEmpty.ff13c74eb8f602e52ebd089741380781.svg";
export { ForwardRef as ReactComponent };